import { render, staticRenderFns } from "./NewPoster.vue?vue&type=template&id=70f514f8&scoped=true&"
import script from "./NewPoster.vue?vue&type=script&lang=js&"
export * from "./NewPoster.vue?vue&type=script&lang=js&"
import style0 from "./NewPoster.vue?vue&type=style&index=0&id=70f514f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f514f8",
  null
  
)

export default component.exports